import axios from 'axios';
import API_BASE_URL from './api';

export const trackEvent = async (payload) => {
  try {
    await axios.post(`${API_BASE_URL}/track`, payload, { withCredentials: false });
  } catch (e) {
    // silence errors
  }
};